import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ReloadKey {
  patientProfileReloadKey : number ;
}

const initialState:ReloadKey = {
    patientProfileReloadKey : 0
};

const patientProfileReloadSlice = createSlice({
  name: "patientProfileReloadKey",
  initialState,
  reducers: {
    setPatientProfileReloadKey(state, action: PayloadAction<number>) {state.patientProfileReloadKey=action.payload},
    clearPatientProfileReloadKey(state) {
      state.patientProfileReloadKey = 0;
    },
  },
});


export const { setPatientProfileReloadKey, clearPatientProfileReloadKey } = patientProfileReloadSlice.actions;

export default patientProfileReloadSlice.reducer;
